<template>
    <CreateShift></CreateShift>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CreateShift = defineAsyncComponent(() =>
    import("../../components/Hr/CreateShift/CreateShift.vue")
);

export default {
    name: "HR_CreateShift", //The name you are in should not equal the name of the component you are importing.
    components: { CreateShift, AuthLayout },
};
</script>

<style scoped></style>
